(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["agnes-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var DUR = 580; /* must be >= the CSS track transition (0.55s) */

    function setX(track, i, animate) {
      if (animate) {
        track.style.transition = '';
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
      } else {
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        void track.offsetWidth; /* commit the jump before re-enabling transition */
        track.style.transition = '';
      }
    }

    /* Reflect the current slide in the mobile step indicators. media._i can be the
       clone index n, which maps back to real slide 0. */
    function updateSteps(media) {
      var steps = media.querySelector('[data-card-steps]');
      if (!steps || !media._n) return;
      var active = ((media._i % media._n) + media._n) % media._n;
      var kids = steps.children;
      for (var k = 0; k < kids.length; k++) {
        kids[k].classList.toggle('is-active', k === active);
      }
    }

    /* Append a clone of the first slide so a forward step past the last image
       continues in the same direction, then snaps back invisibly. */
    function initSlider(media) {
      var track = media.querySelector('[data-card-track]');
      if (!track || track.dataset.loop) return null;
      var n = track.children.length;
      if (n < 2) return null;
      var clone = track.children[0].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      track.dataset.loop = '1';
      media._n = n;
      media._i = 0;
      updateSteps(media);
      return track;
    }

    function go(media, dir) {
      var track = media.querySelector('[data-card-track]');
      if (!track) return;
      if (!track.dataset.loop && !initSlider(media)) return;
      if (media._busy) return;
      var n = media._n;
      media._busy = true;

      if (dir > 0) {
        media._i += 1; /* may land on the clone at index n */
        setX(track, media._i, true);
        updateSteps(media);
        setTimeout(function () {
          if (media._i === n) { media._i = 0; setX(track, 0, false); }
          media._busy = false;
        }, DUR);
      } else {
        if (media._i === 0) {
          /* teleport to the clone (looks identical to slide 0), then slide back */
          setX(track, n, false);
          media._i = n;
        }
        media._i -= 1;
        setX(track, media._i, true);
        updateSteps(media);
        setTimeout(function () { media._busy = false; }, DUR);
      }
    }

    /* Arrow clicks (delegated so filtered cards keep working) */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-card-arrow]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      btn.blur(); /* don't let focus keep the arrows visible after the image changes */
      var media = btn.closest('[data-card-slider]');
      if (media) go(media, btn.hasAttribute('data-card-next') ? 1 : -1);
    });

    /* Touch swipe */
    document.addEventListener('touchstart', function (e) {
      var media = e.target.closest && e.target.closest('[data-card-slider]');
      if (media) media._sx = e.changedTouches[0].clientX;
    }, { passive: true });

    document.addEventListener('touchend', function (e) {
      var media = e.target.closest && e.target.closest('[data-card-slider]');
      if (!media || media._sx == null) return;
      var dx = e.changedTouches[0].clientX - media._sx;
      media._sx = null;
      if (Math.abs(dx) >= 40) go(media, dx < 0 ? 1 : -1);
    }, { passive: true });

    /* Pre-build the clones on load (append-only → no layout shift) */
    function initAll() {
      var list = document.querySelectorAll('[data-card-slider]');
      for (var i = 0; i < list.length; i++) initSlider(list[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
